/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { RepairPlan } from '../models';
// @ts-ignore
import { RepairPlanRow } from '../models';
/**
 * RepairplanApi - axios parameter creator
 * @export
 */
export const RepairplanApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get repairPlan for damagecase
         * @param {number} damageCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesDamageCaseIdRepairPlanGet: async (damageCaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'damageCaseId' is not null or undefined
            assertParamExists('damagecasesDamageCaseIdRepairPlanGet', 'damageCaseId', damageCaseId)
            const localVarPath = `/damagecases/{damageCaseId}/repairPlan`
                .replace(`{${"damageCaseId"}}`, encodeURIComponent(String(damageCaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete the RepairPlan by ID
         * @param {number} id 
         * @param {number} damageCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesDamageCaseIdRepairPlanIdDelete: async (id: number, damageCaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesDamageCaseIdRepairPlanIdDelete', 'id', id)
            // verify required parameter 'damageCaseId' is not null or undefined
            assertParamExists('damagecasesDamageCaseIdRepairPlanIdDelete', 'damageCaseId', damageCaseId)
            const localVarPath = `/damagecases/{damageCaseId}/repairPlan/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"damageCaseId"}}`, encodeURIComponent(String(damageCaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the RepairPlanRow by ID
         * @param {number} id 
         * @param {number} damageCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesDamageCaseIdRepairPlanIdGet: async (id: number, damageCaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesDamageCaseIdRepairPlanIdGet', 'id', id)
            // verify required parameter 'damageCaseId' is not null or undefined
            assertParamExists('damagecasesDamageCaseIdRepairPlanIdGet', 'damageCaseId', damageCaseId)
            const localVarPath = `/damagecases/{damageCaseId}/repairPlan/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"damageCaseId"}}`, encodeURIComponent(String(damageCaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a specific RepairPlanRow
         * @param {number} id 
         * @param {number} damageCaseId 
         * @param {RepairPlanRow} [repairPlanRow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesDamageCaseIdRepairPlanIdPut: async (id: number, damageCaseId: number, repairPlanRow?: RepairPlanRow, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesDamageCaseIdRepairPlanIdPut', 'id', id)
            // verify required parameter 'damageCaseId' is not null or undefined
            assertParamExists('damagecasesDamageCaseIdRepairPlanIdPut', 'damageCaseId', damageCaseId)
            const localVarPath = `/damagecases/{damageCaseId}/repairPlan/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"damageCaseId"}}`, encodeURIComponent(String(damageCaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairPlanRow, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Post repairPlan
         * @param {number} damageCaseId 
         * @param {RepairPlan} [repairPlan] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesDamageCaseIdRepairPlanPost: async (damageCaseId: number, repairPlan?: RepairPlan, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'damageCaseId' is not null or undefined
            assertParamExists('damagecasesDamageCaseIdRepairPlanPost', 'damageCaseId', damageCaseId)
            const localVarPath = `/damagecases/{damageCaseId}/repairPlan`
                .replace(`{${"damageCaseId"}}`, encodeURIComponent(String(damageCaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairPlan, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Post repairPlanRows
         * @param {number} id The id of the company to retrieve
         * @param {Array<RepairPlanRow>} [repairPlanRow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairPlanIdRepairPlanRowBatchPost: async (id: number, repairPlanRow?: Array<RepairPlanRow>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('repairPlanIdRepairPlanRowBatchPost', 'id', id)
            const localVarPath = `/repairPlan/{id}/repairPlanRow/batch`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairPlanRow, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all repairPlanRow
         * @param {number} id The id of the company to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairPlanIdRepairPlanRowGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('repairPlanIdRepairPlanRowGet', 'id', id)
            const localVarPath = `/repairPlan/{id}/repairPlanRow`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Post repairPlanRow
         * @param {number} id The id of the company to retrieve
         * @param {RepairPlanRow} [repairPlanRow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairPlanIdRepairPlanRowPost: async (id: number, repairPlanRow?: RepairPlanRow, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('repairPlanIdRepairPlanRowPost', 'id', id)
            const localVarPath = `/repairPlan/{id}/repairPlanRow`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairPlanRow, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete the RepairPlanRow by ID
         * @param {number} repairPlanId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairPlanRepairPlanIdRepairPlanRowIdDelete: async (repairPlanId: number, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'repairPlanId' is not null or undefined
            assertParamExists('repairPlanRepairPlanIdRepairPlanRowIdDelete', 'repairPlanId', repairPlanId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('repairPlanRepairPlanIdRepairPlanRowIdDelete', 'id', id)
            const localVarPath = `/repairPlan/{repairPlanId}/repairPlanRow/{id}`
                .replace(`{${"repairPlanId"}}`, encodeURIComponent(String(repairPlanId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the RepairPlanRow by ID
         * @param {number} repairPlanId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairPlanRepairPlanIdRepairPlanRowIdGet: async (repairPlanId: number, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'repairPlanId' is not null or undefined
            assertParamExists('repairPlanRepairPlanIdRepairPlanRowIdGet', 'repairPlanId', repairPlanId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('repairPlanRepairPlanIdRepairPlanRowIdGet', 'id', id)
            const localVarPath = `/repairPlan/{repairPlanId}/repairPlanRow/{id}`
                .replace(`{${"repairPlanId"}}`, encodeURIComponent(String(repairPlanId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a specific RepairPlanRow
         * @param {number} repairPlanId 
         * @param {number} id 
         * @param {RepairPlanRow} [repairPlanRow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairPlanRepairPlanIdRepairPlanRowIdPut: async (repairPlanId: number, id: number, repairPlanRow?: RepairPlanRow, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'repairPlanId' is not null or undefined
            assertParamExists('repairPlanRepairPlanIdRepairPlanRowIdPut', 'repairPlanId', repairPlanId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('repairPlanRepairPlanIdRepairPlanRowIdPut', 'id', id)
            const localVarPath = `/repairPlan/{repairPlanId}/repairPlanRow/{id}`
                .replace(`{${"repairPlanId"}}`, encodeURIComponent(String(repairPlanId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairPlanRow, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RepairplanApi - functional programming interface
 * @export
 */
export const RepairplanApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RepairplanApiAxiosParamCreator(configuration)
    return {
        /**
         * Get repairPlan for damagecase
         * @param {number} damageCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesDamageCaseIdRepairPlanGet(damageCaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairPlan>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesDamageCaseIdRepairPlanGet(damageCaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete the RepairPlan by ID
         * @param {number} id 
         * @param {number} damageCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesDamageCaseIdRepairPlanIdDelete(id: number, damageCaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesDamageCaseIdRepairPlanIdDelete(id, damageCaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the RepairPlanRow by ID
         * @param {number} id 
         * @param {number} damageCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesDamageCaseIdRepairPlanIdGet(id: number, damageCaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairPlanRow>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesDamageCaseIdRepairPlanIdGet(id, damageCaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a specific RepairPlanRow
         * @param {number} id 
         * @param {number} damageCaseId 
         * @param {RepairPlanRow} [repairPlanRow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesDamageCaseIdRepairPlanIdPut(id: number, damageCaseId: number, repairPlanRow?: RepairPlanRow, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairPlanRow>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesDamageCaseIdRepairPlanIdPut(id, damageCaseId, repairPlanRow, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Post repairPlan
         * @param {number} damageCaseId 
         * @param {RepairPlan} [repairPlan] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesDamageCaseIdRepairPlanPost(damageCaseId: number, repairPlan?: RepairPlan, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairPlan>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesDamageCaseIdRepairPlanPost(damageCaseId, repairPlan, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Post repairPlanRows
         * @param {number} id The id of the company to retrieve
         * @param {Array<RepairPlanRow>} [repairPlanRow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairPlanIdRepairPlanRowBatchPost(id: number, repairPlanRow?: Array<RepairPlanRow>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairPlanRow>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairPlanIdRepairPlanRowBatchPost(id, repairPlanRow, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all repairPlanRow
         * @param {number} id The id of the company to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairPlanIdRepairPlanRowGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RepairPlanRow>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairPlanIdRepairPlanRowGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Post repairPlanRow
         * @param {number} id The id of the company to retrieve
         * @param {RepairPlanRow} [repairPlanRow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairPlanIdRepairPlanRowPost(id: number, repairPlanRow?: RepairPlanRow, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairPlanRow>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairPlanIdRepairPlanRowPost(id, repairPlanRow, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete the RepairPlanRow by ID
         * @param {number} repairPlanId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairPlanRepairPlanIdRepairPlanRowIdDelete(repairPlanId: number, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairPlanRepairPlanIdRepairPlanRowIdDelete(repairPlanId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the RepairPlanRow by ID
         * @param {number} repairPlanId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairPlanRepairPlanIdRepairPlanRowIdGet(repairPlanId: number, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairPlanRow>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairPlanRepairPlanIdRepairPlanRowIdGet(repairPlanId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a specific RepairPlanRow
         * @param {number} repairPlanId 
         * @param {number} id 
         * @param {RepairPlanRow} [repairPlanRow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairPlanRepairPlanIdRepairPlanRowIdPut(repairPlanId: number, id: number, repairPlanRow?: RepairPlanRow, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairPlanRow>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairPlanRepairPlanIdRepairPlanRowIdPut(repairPlanId, id, repairPlanRow, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RepairplanApi - factory interface
 * @export
 */
export const RepairplanApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RepairplanApiFp(configuration)
    return {
        /**
         * Get repairPlan for damagecase
         * @param {number} damageCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesDamageCaseIdRepairPlanGet(damageCaseId: number, options?: any): AxiosPromise<RepairPlan> {
            return localVarFp.damagecasesDamageCaseIdRepairPlanGet(damageCaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete the RepairPlan by ID
         * @param {number} id 
         * @param {number} damageCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesDamageCaseIdRepairPlanIdDelete(id: number, damageCaseId: number, options?: any): AxiosPromise<void> {
            return localVarFp.damagecasesDamageCaseIdRepairPlanIdDelete(id, damageCaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the RepairPlanRow by ID
         * @param {number} id 
         * @param {number} damageCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesDamageCaseIdRepairPlanIdGet(id: number, damageCaseId: number, options?: any): AxiosPromise<RepairPlanRow> {
            return localVarFp.damagecasesDamageCaseIdRepairPlanIdGet(id, damageCaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a specific RepairPlanRow
         * @param {number} id 
         * @param {number} damageCaseId 
         * @param {RepairPlanRow} [repairPlanRow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesDamageCaseIdRepairPlanIdPut(id: number, damageCaseId: number, repairPlanRow?: RepairPlanRow, options?: any): AxiosPromise<RepairPlanRow> {
            return localVarFp.damagecasesDamageCaseIdRepairPlanIdPut(id, damageCaseId, repairPlanRow, options).then((request) => request(axios, basePath));
        },
        /**
         * Post repairPlan
         * @param {number} damageCaseId 
         * @param {RepairPlan} [repairPlan] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesDamageCaseIdRepairPlanPost(damageCaseId: number, repairPlan?: RepairPlan, options?: any): AxiosPromise<RepairPlan> {
            return localVarFp.damagecasesDamageCaseIdRepairPlanPost(damageCaseId, repairPlan, options).then((request) => request(axios, basePath));
        },
        /**
         * Post repairPlanRows
         * @param {number} id The id of the company to retrieve
         * @param {Array<RepairPlanRow>} [repairPlanRow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairPlanIdRepairPlanRowBatchPost(id: number, repairPlanRow?: Array<RepairPlanRow>, options?: any): AxiosPromise<RepairPlanRow> {
            return localVarFp.repairPlanIdRepairPlanRowBatchPost(id, repairPlanRow, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all repairPlanRow
         * @param {number} id The id of the company to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairPlanIdRepairPlanRowGet(id: number, options?: any): AxiosPromise<Array<RepairPlanRow>> {
            return localVarFp.repairPlanIdRepairPlanRowGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Post repairPlanRow
         * @param {number} id The id of the company to retrieve
         * @param {RepairPlanRow} [repairPlanRow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairPlanIdRepairPlanRowPost(id: number, repairPlanRow?: RepairPlanRow, options?: any): AxiosPromise<RepairPlanRow> {
            return localVarFp.repairPlanIdRepairPlanRowPost(id, repairPlanRow, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete the RepairPlanRow by ID
         * @param {number} repairPlanId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairPlanRepairPlanIdRepairPlanRowIdDelete(repairPlanId: number, id: number, options?: any): AxiosPromise<void> {
            return localVarFp.repairPlanRepairPlanIdRepairPlanRowIdDelete(repairPlanId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the RepairPlanRow by ID
         * @param {number} repairPlanId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairPlanRepairPlanIdRepairPlanRowIdGet(repairPlanId: number, id: number, options?: any): AxiosPromise<RepairPlanRow> {
            return localVarFp.repairPlanRepairPlanIdRepairPlanRowIdGet(repairPlanId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a specific RepairPlanRow
         * @param {number} repairPlanId 
         * @param {number} id 
         * @param {RepairPlanRow} [repairPlanRow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairPlanRepairPlanIdRepairPlanRowIdPut(repairPlanId: number, id: number, repairPlanRow?: RepairPlanRow, options?: any): AxiosPromise<RepairPlanRow> {
            return localVarFp.repairPlanRepairPlanIdRepairPlanRowIdPut(repairPlanId, id, repairPlanRow, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RepairplanApi - object-oriented interface
 * @export
 * @class RepairplanApi
 * @extends {BaseAPI}
 */
export class RepairplanApi extends BaseAPI {
    /**
     * Get repairPlan for damagecase
     * @param {number} damageCaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairplanApi
     */
    public damagecasesDamageCaseIdRepairPlanGet(damageCaseId: number, options?: AxiosRequestConfig) {
        return RepairplanApiFp(this.configuration).damagecasesDamageCaseIdRepairPlanGet(damageCaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete the RepairPlan by ID
     * @param {number} id 
     * @param {number} damageCaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairplanApi
     */
    public damagecasesDamageCaseIdRepairPlanIdDelete(id: number, damageCaseId: number, options?: AxiosRequestConfig) {
        return RepairplanApiFp(this.configuration).damagecasesDamageCaseIdRepairPlanIdDelete(id, damageCaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the RepairPlanRow by ID
     * @param {number} id 
     * @param {number} damageCaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairplanApi
     */
    public damagecasesDamageCaseIdRepairPlanIdGet(id: number, damageCaseId: number, options?: AxiosRequestConfig) {
        return RepairplanApiFp(this.configuration).damagecasesDamageCaseIdRepairPlanIdGet(id, damageCaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a specific RepairPlanRow
     * @param {number} id 
     * @param {number} damageCaseId 
     * @param {RepairPlanRow} [repairPlanRow] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairplanApi
     */
    public damagecasesDamageCaseIdRepairPlanIdPut(id: number, damageCaseId: number, repairPlanRow?: RepairPlanRow, options?: AxiosRequestConfig) {
        return RepairplanApiFp(this.configuration).damagecasesDamageCaseIdRepairPlanIdPut(id, damageCaseId, repairPlanRow, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Post repairPlan
     * @param {number} damageCaseId 
     * @param {RepairPlan} [repairPlan] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairplanApi
     */
    public damagecasesDamageCaseIdRepairPlanPost(damageCaseId: number, repairPlan?: RepairPlan, options?: AxiosRequestConfig) {
        return RepairplanApiFp(this.configuration).damagecasesDamageCaseIdRepairPlanPost(damageCaseId, repairPlan, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Post repairPlanRows
     * @param {number} id The id of the company to retrieve
     * @param {Array<RepairPlanRow>} [repairPlanRow] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairplanApi
     */
    public repairPlanIdRepairPlanRowBatchPost(id: number, repairPlanRow?: Array<RepairPlanRow>, options?: AxiosRequestConfig) {
        return RepairplanApiFp(this.configuration).repairPlanIdRepairPlanRowBatchPost(id, repairPlanRow, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all repairPlanRow
     * @param {number} id The id of the company to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairplanApi
     */
    public repairPlanIdRepairPlanRowGet(id: number, options?: AxiosRequestConfig) {
        return RepairplanApiFp(this.configuration).repairPlanIdRepairPlanRowGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Post repairPlanRow
     * @param {number} id The id of the company to retrieve
     * @param {RepairPlanRow} [repairPlanRow] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairplanApi
     */
    public repairPlanIdRepairPlanRowPost(id: number, repairPlanRow?: RepairPlanRow, options?: AxiosRequestConfig) {
        return RepairplanApiFp(this.configuration).repairPlanIdRepairPlanRowPost(id, repairPlanRow, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete the RepairPlanRow by ID
     * @param {number} repairPlanId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairplanApi
     */
    public repairPlanRepairPlanIdRepairPlanRowIdDelete(repairPlanId: number, id: number, options?: AxiosRequestConfig) {
        return RepairplanApiFp(this.configuration).repairPlanRepairPlanIdRepairPlanRowIdDelete(repairPlanId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the RepairPlanRow by ID
     * @param {number} repairPlanId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairplanApi
     */
    public repairPlanRepairPlanIdRepairPlanRowIdGet(repairPlanId: number, id: number, options?: AxiosRequestConfig) {
        return RepairplanApiFp(this.configuration).repairPlanRepairPlanIdRepairPlanRowIdGet(repairPlanId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a specific RepairPlanRow
     * @param {number} repairPlanId 
     * @param {number} id 
     * @param {RepairPlanRow} [repairPlanRow] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairplanApi
     */
    public repairPlanRepairPlanIdRepairPlanRowIdPut(repairPlanId: number, id: number, repairPlanRow?: RepairPlanRow, options?: AxiosRequestConfig) {
        return RepairplanApiFp(this.configuration).repairPlanRepairPlanIdRepairPlanRowIdPut(repairPlanId, id, repairPlanRow, options).then((request) => request(this.axios, this.basePath));
    }
}
